import React from 'react';
import c from 'classnames';
import { List } from 'immutable';
import { Fade } from 'react-awesome-reveal';

import { Paragraph } from '@uncinc/react-drupal-core';
import { Container, useWindowDimensions, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_NORMAL, SCREEN_TABLET } from '../../../config/constants';

import './style.scss';

const ParagraphCards = ({ entity }) => {
  const anchor = entity.getIn(['field_anchor', 0, 'value']);
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'value']);
  const amount = entity.get('field_paragraphs').size;
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;
  const cardsClassName = c('Paragraph Cards', `Cards-${amount}`);
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const isNormal = width >= SCREEN_NORMAL;

  return (
    <Container>
      <div id={paragraphKey} className={cardsClassName}>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <h2 className="Cards__title">{title}</h2>
            {body && (
              <WysiwygField html={body} className="Cards__body" />
            )}
          </div>
        </div>
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <div className="row">
            {anchor && <a id={anchor} />}
            {
              entity.getIn(['field_paragraphs'], List()).map((item, index) => {
                const paragraphId = item.get('target_id');
                const paragraph = item.get('entity');
                const paragraphKey = `paragraph:${paragraphId}`;
                let className = c('CardWrapper', {
                  'col-sm-12 large-third': amount === 3 && index === 2 && isMobile,
                  'col-sm-4 thirds': amount === 3 && !isMobile,
                  'col-md-3': amount === 4 && isNormal,
                  'left-card': (index === 0 || index === 2 && amount !== 3),
                  'right-card': (index === 1 || index === 3),
                });
                return (
                  <div key={paragraphKey} id={paragraphKey} className={className}>
                    <Paragraph entity={paragraph} id={paragraphId} key={paragraphId} amount={amount} />
                  </div>
                );
              })
            }
          </div>
        </Fade>
      </div>
    </Container>
  );
};

export default ParagraphCards;
